import SessionManager from '@numa-group/numa-session-id-manager';
import type { Context, Plugin } from '@segment/analytics-next';
import Cookies from 'js-cookie';

import { GA4_MEASUREMENT_ID } from '@src/constants/analytics';
import { Brand } from '@src/types/content/brand';

import { getGa4ClientId } from './get-ga4-client-id';

/**
 * Custom segment plugin enriching each event (page, track & identify) with ga4ClientId, pageType and consent status.
 */
export const segmentEnrichmentPlugin = (brand: Brand): Plugin => {
  let ga4ClientId: string | undefined;
  let isLoaded = false;

  const enrichEvent = async (ctx: Context) => {
    const domain = new URL(brand.websiteUrl).host;
    const sessionManager = new SessionManager({
      getter: Cookies.get,
      setter: Cookies.set,
      domain,
    });
    const sessionId = await sessionManager.getRefreshedSessionID();

    ctx.updateEvent('properties.session_id', sessionId);
    ctx.updateEvent('properties.ga4_client_id', ga4ClientId);
    ctx.updateEvent('context', {
      ...ctx.event.context,
      consent: ctx.event.integrations,
    });

    ctx.updateEvent('integrations', {
      ...ctx.event.integrations,
      'Google Analytics 4': !!ga4ClientId,
    });

    return ctx;
  };

  return {
    name: 'Custom Enrichment',
    type: 'enrichment',
    version: '1.0.0',

    isLoaded: () => isLoaded,
    load: async () => {
      ga4ClientId = await getGa4ClientId(GA4_MEASUREMENT_ID);
      isLoaded = true;
    },

    track: (ctx: Context) => enrichEvent(ctx),
    page: (ctx: Context) => enrichEvent(ctx),
    identify: (ctx: Context) => enrichEvent(ctx),
  };
};
